import { render } from "./profile-form.vue?vue&type=template&id=01428920&scoped=true"
import script from "./profile-form.vue?vue&type=script&lang=js"
export * from "./profile-form.vue?vue&type=script&lang=js"

import "./profile-form.vue?vue&type=style&index=0&id=01428920&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01428920"]])

export default __exports__